// actions.js
import {
  ADD_TEAM_MEMBER_REQUEST,
  ADD_TEAM_MEMBER_SUCCESS,
  ADD_TEAM_MEMBER_FAILURE,
  UPDATE_TEAM_MEMBER_REQUEST,
  UPDATE_TEAM_MEMBER_SUCCESS,
  UPDATE_TEAM_MEMBER_FAILURE,
  DELETE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAILURE,
  GET_TEAM_MEMBERS_REQUEST,
  GET_TEAM_MEMBERS_SUCCESS,
  GET_TEAM_MEMBERS_FAILURE,
} from './actionTypes'

// Action to get the list of team members
export const getTeamMembersRequest = (id) => ({
  type: GET_TEAM_MEMBERS_REQUEST,
  payload: id
})

export const getTeamMembersSuccess = (members) => ({
  type: GET_TEAM_MEMBERS_SUCCESS,
  payload: members,
})

export const getTeamMembersFailure = (error) => ({
  type: GET_TEAM_MEMBERS_FAILURE,
  payload: error,
})

// Action to add a new team member
export const addTeamMemberRequest = (newMember) => ({
  type: ADD_TEAM_MEMBER_REQUEST,
  payload: newMember,
})

export const addTeamMemberSuccess = (member) => ({
  type: ADD_TEAM_MEMBER_SUCCESS,
  payload: member,
})

export const addTeamMemberFailure = (error) => ({
  type: ADD_TEAM_MEMBER_FAILURE,
  payload: error,
})

// Action to update an existing team member
export const updateTeamMemberRequest = (updatedMember) => ({
  type: UPDATE_TEAM_MEMBER_REQUEST,
  payload: updatedMember,
})

export const updateTeamMemberSuccess = (member) => ({
  type: UPDATE_TEAM_MEMBER_SUCCESS,
  payload: member,
})

export const updateTeamMemberFailure = (error) => ({
  type: UPDATE_TEAM_MEMBER_FAILURE,
  payload: error,
})

// Action to delete a team member
export const deleteTeamMemberRequest = (member) => ({
  type: DELETE_TEAM_MEMBER_REQUEST,
  payload: member,
})

export const deleteTeamMemberSuccess = (memberId) => ({
  type: DELETE_TEAM_MEMBER_SUCCESS,
  payload: memberId,
})

export const deleteTeamMemberFailure = (error) => ({
  type: DELETE_TEAM_MEMBER_FAILURE,
  payload: error,
})
